import { useEffect, useState } from "react";
import { useNavigate, useSearchParams } from "react-router-dom";
import { exchangeCodeForTokens } from "@/lib/spotify/auth";

const SpotifyCallback = () => {
  const [searchParams] = useSearchParams();
  const navigate = useNavigate();
  const [error, setError] = useState<string | null>(null);

  useEffect(() => {
    const code = searchParams.get("code");
    const authError = searchParams.get("error");

    if (authError) {
      setError(`Spotify authorization failed: ${authError}`);
      setTimeout(() => navigate("/", { replace: true }), 3000);
      return;
    }

    if (!code) {
      setError("No authorization code received");
      setTimeout(() => navigate("/", { replace: true }), 3000);
      return;
    }

    exchangeCodeForTokens(code)
      .then((data) => {
        window.dispatchEvent(
          new CustomEvent("spotify:auth-complete", {
            detail: { access_token: data.access_token },
          }),
        );
        navigate("/", { replace: true });
      })
      .catch((err) => {
        setError(err.message);
        setTimeout(() => navigate("/", { replace: true }), 3000);
      });
  }, [searchParams, navigate]);

  return (
    <div className="min-h-screen flex items-center justify-center bg-background">
      <div className="text-center space-y-4">
        {error ? (
          <>
            <p className="text-destructive text-lg">{error}</p>
            <p className="text-muted-foreground text-sm">Redirecting...</p>
          </>
        ) : (
          <>
            <div className="animate-spin h-8 w-8 border-2 border-primary border-t-transparent rounded-full mx-auto" />
            <p className="text-muted-foreground">Connecting to Spotify...</p>
          </>
        )}
      </div>
    </div>
  );
};

export default SpotifyCallback;
